module.exports = __webpack_public_path__ + "static/img/feiji2.748e26dd.png";